import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { fetchSite } from "@/lib/api";

const THEME_VARS = ["primary", "night", "cta", "link", "sky", "text", "slate", "bg", "border", "success"];

export const useSite = () => {
  const q = useQuery({ queryKey: ["site"], queryFn: fetchSite, staleTime: 60_000, refetchOnWindowFocus: true });
  const theme = q.data?.settings?.theme;
  useEffect(() => {
    if (!theme) return;
    THEME_VARS.forEach((k) => theme[k] && document.documentElement.style.setProperty(`--pp-${k}`, theme[k]));
  }, [theme]);
  return q;
};

export const useSeo = (title, description, opts = {}) => {
  const { pathname } = useLocation();
  const override = useSite().data?.settings?.seo_pages?.[pathname];
  if (override?.title) title = override.title;
  if (override?.description) description = override.description;
  useEffect(() => {
    if (!title) return;
    const url = `${window.location.origin}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;
    document.title = title;
    const set = (sel, val, attr = "content") => document.querySelector(sel)?.setAttribute(attr, val);
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', title);
    set('meta[property="og:description"]', description);
    set('meta[property="og:url"]', url);
    set('link[rel="canonical"]', url, "href");
    const meta = (attr, key, val) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!val) { el?.remove(); return; }
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", val);
    };
    meta("property", "og:type", opts.type || "website");
    meta("property", "og:image", opts.image || "");
    meta("name", "twitter:image", opts.image || "");
    meta("name", "robots", opts.noindex ? "noindex, nofollow" : "");
  }, [title, description, pathname, opts.type, opts.image, opts.noindex]);
};
